module.exports = __webpack_public_path__ + "img/Frame5.b05de44b.png";